import type { LucideIcon } from 'lucide-react'
import * as React from 'react'
import { forwardRef } from 'react'

export const LetterIcon: LucideIcon = forwardRef(({ size = 24, color = 'white', ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox='0 0 24 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M22 1.5H2C1.724 1.5 1.5 1.7239 1.5 2V14C1.5 14.2761 1.724 14.5 2 14.5H22C22.276 14.5 22.5 14.2761 22.5 14V2C22.5 1.7239 22.276 1.5 22 1.5ZM2 0C0.895 0 0 0.8954 0 2V14C0 15.1046 0.895 16 2 16H22C23.105 16 24 15.1046 24 14V2C24 0.8954 23.105 0 22 0H2Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.01196 7.98985L0.585938 15.4155C0.947937 15.7768 1.44696 16.0002 1.99896 16.0002H21.999C22.551 16.0002 23.05 15.7768 23.412 15.4155L23.4139 15.4133L15.957 7.95605L14.8959 9.01675L20.3799 14.5002H3.62195L9.07196 9.05055L8.01196 7.98985Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M23.3707 0.543403C23.0127 0.206404 22.5307 0 22.0007 0H2.00067C1.45467 0 0.958656 0.219202 0.597656 0.574402L10.5547 10.5312C11.3357 11.3123 12.6027 11.3123 13.3837 10.5312L23.3707 0.543403ZM20.2937 1.5H3.64465L11.6157 9.47059C11.8107 9.66579 12.1277 9.66579 12.3227 9.47059L20.2937 1.5Z'
        fill={color}
      />
    </svg>
  )
})

LetterIcon.displayName = 'LetterIcon'
